import React, { useRef } from "react";

/**
 * Wraps a child element so it gently follows the cursor when the pointer is
 * within `radius` pixels. Enabled on devices with a fine pointer (no touch).
 */
export default function MagneticHover({
    children,
    strength = 0.35,
    radius = 120,
    className = "",
}) {
    const ref = useRef(null);

    const onMouseMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dx = e.clientX - cx;
        const dy = e.clientY - cy;
        const dist = Math.hypot(dx, dy);
        if (dist > radius) {
            el.style.transform = "translate(0px, 0px)";
            return;
        }
        el.style.transform = `translate(${dx * strength}px, ${dy * strength}px)`;
    };

    const reset = () => {
        const el = ref.current;
        if (el) el.style.transform = "translate(0px, 0px)";
    };

    return (
        <span
            onMouseMove={onMouseMove}
            onMouseLeave={reset}
            className={`inline-block ${className}`}
        >
            <span
                ref={ref}
                className="inline-block transition-transform duration-300 will-change-transform"
            >
                {children}
            </span>
        </span>
    );
}
